import React from 'react';
import { getMessage } from '@tcc/i18n';
import { RegionReportFooter } from '../../RegionReportFooter/RegionReportFooter';
import { RegionThumbnailNoteBox } from '../../RegionReportThumbnailNoteBox/RegionThumbnailNoteBox';
import styles from '../../RegionReport.css';

export type NoHarvestDataViewProps = {
  activity: React.ComponentProps<typeof RegionThumbnailNoteBox>['activity'] | null | undefined;
  activityExists: boolean;
  fieldName: string;
  geoJson: React.ComponentProps<typeof RegionThumbnailNoteBox>['geoJson'];
  isRegionValid: boolean | null;
  locale: string;
  onCancelConfirm: () => void;
  onDeleteConfirm: () => void;
  onRegionButtonClick: () => void;
  saveClick: () => void;
  showSaveButton: boolean;
};

export const NoHarvestDataView = ({
  activity,
  activityExists,
  fieldName,
  geoJson,
  isRegionValid,
  locale,
  onCancelConfirm,
  onDeleteConfirm,
  onRegionButtonClick,
  saveClick,
  showSaveButton,
}: NoHarvestDataViewProps) => (
  <div data-test-id='dmb-region-report-no-harvest-data'>
    <h2 className={styles.title}>
      {getMessage('regions.report.modal.title')}
    </h2>
    <div className={styles.noHarvestDataWrapper}>
      {activity && (
        <RegionThumbnailNoteBox
          activity={activity}
          fieldName={fieldName}
          geoJson={geoJson}
          locale={locale}
          onRegionButtonClick={onRegionButtonClick}
          isClickable={activityExists}
          displayNoteButton={activityExists}
        />
      )}
      <p
        className={styles.noHarvestMessage}
        data-test-id='dmb-region-report-no-harvest-data-message'
      >
        {!isRegionValid
          ? getMessage('regions.report.modal.noHarvestDataRegion')
          : getMessage('regions.report.modal.noHarvestData')}
      </p>
    </div>
    <RegionReportFooter
      onCancelClick={onCancelConfirm}
      onDeleteClick={onDeleteConfirm}
      saveClick={saveClick}
      showSaveButton={showSaveButton}
    />
  </div>
);
